module.exports = __webpack_public_path__ + "static/media/grab_sm.41d83082.png";